module.exports = __webpack_public_path__ + "img/laminate_one.498327ff.png";